import { } from 'vue';
import { FilterSelectionDate, FilterSelectionLocation, FilterSelectionCompanions } from '@Types/FilterSelections';


export  class FilterModel {

    accommodationTypes = new Array<number>();
    accommodationTypeNoPreference = true;
    criteria = [] as Array<Array<number>>;
    bedrooms = 1;
    bathrooms = 1;
 
    date = new FilterSelectionDate();
    location = new FilterSelectionLocation();
    companions = new FilterSelectionCompanions();
    orderBy?: string = "";
   
    public clearCriteria(): void {

        this.criteria.forEach(c => c.splice(0));
    }
}

// class that maps to a querystring set of variables that define a single property 
export class FilterParamEntry {

    paramId: number;
    amount: number | null;
    minValue: number | null;
    values: number[];

    constructor() {

        this.values = [];
        this.amount = null;
        this.minValue = null;
        this.paramId = 0;
    }
}

